module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.7@core-js/library/modules/_redefine.js
// module id = 52
// module chunks = 0